import { RoleAndWarehouseSelector } from 'app/components/features/RoleAndWarehouseSelector';
import { SnowflakeConnectionStatus } from './SnowflakeConnectionStatus.jsx';
import * as styles from './SnowflakeConnectionStatus.css';

export function SnowflakeStatusInfo() {
    return (
        <div className={styles.snowflakeStatusContainer}>
            <SnowflakeConnectionStatus />
            <div className={styles.separator} />
            <RoleAndWarehouseSelector className={styles.selector} />
        </div>
    );
}
